import { useEffect, useState } from "react";
import { api } from "../api/client";

interface Template {
  id: string;
  label: string;
  body: string;
}

export function TemplatesButton({ mailboxId, onPick }: { mailboxId: string; onPick: (body: string) => void }) {
  const [open, setOpen] = useState(false);
  const [templates, setTemplates] = useState<Template[]>([]);

  useEffect(() => {
    if (!open) return;
    api.get<{ templates: Template[] }>(`/api/mailboxes/${mailboxId}/voice`).then((r) => setTemplates(r.templates));
  }, [open, mailboxId]);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button className="btn btn-ghost" onClick={() => setOpen((v) => !v)}>Templates</button>
      {open && (
        <div className="card card-raised" style={{ position: "absolute", bottom: "100%", left: 0, marginBottom: 4, width: 240, zIndex: 20, padding: 4 }}>
          {templates.length === 0 && <div style={{ padding: 8, fontSize: 11.5, color: "var(--gm-text-4)" }}>No templates yet — learn your voice from Settings → Account.</div>}
          {templates.map((t) => (
            <button
              key={t.id}
              className="gm-nav-row"
              onClick={() => {
                onPick(t.body);
                setOpen(false);
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
